<script>
import _ from 'lodash';
import { VTextField } from 'vuetify/lib';
import BReadOnlyTextField from './BReadOnlyTextField';
import ValidationField from "@/components/base_components/ValidationField";

export default {
  functional: true,
  props: {
    readOnly: { type: Boolean, default: false },
    uuid: String,
    propPath: String,
    formRef: String,
    showUserMessageError: {
      type: Boolean,
      default: false
    },
    ...VTextField.options.props
  },
  render(createElement, context) {
    if (!context.props.readOnly) {
      const customData = {
        class: [
          'b-text-field--input',
          { 'b-text-field--input--has-label': context.props.label }
        ],
        props: {
          outlined: true,
          dense: true,
          hideDetails: 'auto'
        }
      };
      context.data.props = context.props;
      _.mergeWith(context.data, customData, function(objValue, srcValue) {
        if (_.isArray(objValue)) return objValue.concat(srcValue);
      });

      const slot = ({ error, deleteServerError, hint }) => {
        const data = {
          ...context.data,
          props: {
            ...context.data.props,
            hint: hint
          },
          on: {
            ...context.data.on,
            keyup: () => deleteServerError(),
            input: () => deleteServerError(),
          }
        }
        if (error !== undefined) {
          data.props.errorMessages = error;
        }
        return createElement(VTextField, data);
      }

      return createElement(ValidationField,
          {
            props: {
              uuid: context.data.props.uuid,
              propPath: context.data.props.propPath,
              formRef: context.data.props.formRef,
              showUserMessageError: context.data.props.showUserMessageError
            },
            scopedSlots: { default: slot }
          });
    } else {
      context.data.props = context.props;
      return createElement(BReadOnlyTextField, context.data);
    }
  }
};
</script>

<style lang="scss" >
.b-text-field--input--has-label {
  & > .v-input__control {
    padding-top: 4px;
  }
}
</style>
